export default "__VITE_ASSET__QFbeDIA1__"